export default "__VITE_ASSET__DPakWtNi__"